module.exports = __webpack_public_path__ + "static/media/11-13.9bfad435.mp3";